import { useMemo } from 'react';
import { DashboardWidgetType } from '../enums/DashboardWidgetType';
import { DashboardWidgetData } from '../interfaces/DashboardWidgetData';
import { dashboardWidgetsData } from '../constants/dashboardWidgetsData';
import { CustomAny } from '../../shared/types/generics';

export function useDashboardWidgetData(type: DashboardWidgetType): DashboardWidgetData<CustomAny> {
  return useMemo(() => dashboardWidgetsData[type], [type]);
}
